import { useCreateArea } from '@/core/domain/operational/Areas/Areas.hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { CreateAreaRequest } from '@/core/domain/operational/Areas/Areas.types';
import { FloatingFormItem } from '@/components/_common';
import { useIntl } from 'react-intl';
import {
  useDefaultEmptyFieldError,
  useDefaultMaxLengthFieldError,
} from '@/hooks';

interface Props extends ModalProps {
  onCancel: VoidFunction;
}

const AreaCreateModal: React.FC<Props> = ({ onCancel, ...props }) => {
  const requiredField = useDefaultEmptyFieldError();
  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  const history = useHistory();
  const intl = useIntl();

  const [form] = Form.useForm<CreateAreaRequest>();

  const mutation = useCreateArea();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const response = await mutation.mutateAsync({ ...values, active: true });

      history.push(`/app/operational/areas/${response.id}`);

      handleCancel();
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();

    onCancel();
  };

  return (
    <Modal
      title="Criação da área"
      width={600}
      onCancel={handleCancel}
      onOk={handleSaveClick}
      confirmLoading={mutation.isLoading}
      okText="Criar"
      {...props}
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem
              name="name"
              label={intl.formatMessage({
                id: 'areas.general.form.description',
              })}
              rules={[requiredField, defaultMaxLenghtFieldError(200)]}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AreaCreateModal;
